import { useState } from 'react';
import { generateShareDescriptionAPI } from '../apis/aiApis';
const useShareModal = (defaultConfig = {}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [shareConfig, setShareConfig] = useState({
    shareUrl: window.location.href,
    title: "Check this out!",
    description: "I found this amazing content. Have a look!",
    hashtags: ["FundLife", "Charity", "Donation"],
    pageId:"",
    ...defaultConfig
  });

  const openShareModal = (config = {}) => {
    setShareConfig(prev => ({ ...prev, ...config }));
    setIsOpen(true);
  };

  const closeShareModal = () => {
    setIsOpen(false);
  };

  const updateShareConfig = (newConfig) => {
    setShareConfig(prev => ({ ...prev, ...newConfig }));
  };

  const [isGenerating, setIsGenerating] = useState(false);
  const [generateError, setGenerateError] = useState(null);

  const generateDescription = async (opts = {}) => {
    setGenerateError(null);
    setIsGenerating(true);
    try {
      const { title, shareUrl, hashtags, descriptionHint, audience, maxChars, platform,pageId } = {
        title: shareConfig.title,
        shareUrl: shareConfig.shareUrl,
        hashtags: shareConfig.hashtags,
        pageId:shareConfig.pageId,
        platform: '',
        ...opts,
      };

      const description = await generateShareDescriptionAPI({
        title,
        url: shareUrl,
        hashtags,
        descriptionHint,
        pageId,
        audience,
        maxChars: maxChars || 180,
        platform,
      });
      setShareConfig((prev) => ({ ...prev, description }));
      return description;
    } catch (e) {
      setGenerateError(e?.response?.data?.message || e?.message || 'Failed to generate');
      return null;
    } finally {
      setIsGenerating(false);
    }
  };

  return {
    isOpen,
    shareConfig,
    openShareModal,
    closeShareModal,
    updateShareConfig
    , isGenerating
    , generateError
    , generateDescription
  };
};

export default useShareModal;